function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { flushSync } from 'react-dom';
import { useSelector } from 'react-redux';
import claimProjectReportsListsService from '../services/lists/claim_groups/claim_project_reports_lists.service';
import ModelInstanceSelector from '../dashboards/components/ModelInstanceSelector';
import { buildQueryString } from '../services/service';

/**
 * 
 * @param {Object} queryParams - key-value pairs. Each key is passed as a query parameter. You can also pass a 'query' key which is an object. Each key-value pair is used to build a query string.
 *    The search project name is attached to that query string.
 *    E.g.: { group_projects: false, query: code: '123' } => { group_projects: false, query: "projec_name=SomeProject&code=123" }
 *    This object is then passed to the service.
 *                  
 * @returns 
 */
export const ProjectSelector = _ref => {
  let {
    claimGroupId,
    className = '',
    alreadySelectedInstances = [],
    excludeAlreadySelectedInstances = false,
    onChange,
    onBlur,
    onSelectInstance,
    eventFieldName,
    queryParams = {},
    searchInputRef
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const [reports, setReports, totalPages, setTotalPages, params, setParams, fetchAllProjetcs] = claimProjectReportsListsService.useFetchAll({
    accountType: user.account_type,
    claimGroupId,
    groupProjects: false,
    fetchImmediatelly: false
  });
  const alreadySelectedInstanceIds = new Set(alreadySelectedInstances.map(instance => instance === null || instance === void 0 ? void 0 : instance.id).filter(id => id !== undefined && id !== null));
  const fetchProjectsByName = async projectName => {
    const fullQueryString = buildQueryString(_objectSpread(_objectSpread({}, queryParams.query || {}), {}, {
      project_name: projectName
    }));
    const filteredProjects = await fetchAllProjetcs(_objectSpread(_objectSpread({}, queryParams), {}, {
      query: fullQueryString
    }));
    return {
      values: excludeAlreadySelectedInstances ? filteredProjects.claim_project_reports.filter(project => !alreadySelectedInstanceIds.has(project.id)) : filteredProjects.claim_project_reports,
      totalPages: filteredProjects.pages
    };
  };
  const buildEventLikeObject = value => {
    return {
      target: {
        type: 'select',
        value,
        name: eventFieldName
      },
      preventDefault: () => {},
      stopPropagation: () => {},
      stopImmediatePropagation: () => {}
    };
  };
  return /*#__PURE__*/React.createElement(ModelInstanceSelector, {
    className: className,
    allowMultipleSelection: false,
    selectInstances: async project => {
      const event = buildEventLikeObject(project.id);
      flushSync(() => {
        onChange(event);
      });
      onBlur(event);
      onSelectInstance && onSelectInstance(project);
    },
    onSearch: fetchProjectsByName,
    alreadySelectedInstances: alreadySelectedInstances,
    displayTextKey: 'project_name',
    searchInputRef: searchInputRef
  });
};